import { FC, useState } from "react";
import { TextField, useForm, useModal } from "@refinedev/antd";
import { AppViewCard } from "../../../../components";
import { errorNotification, successNotification } from "../../../../helpers";
import { CloseOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Form, Input, Space, Modal } from "antd";
import { useDelete } from "@refinedev/core";
import s from "./Matches-Description.module.scss";
import { MatchDescription } from "../../Lib/types";

type MatchesDescriptionProps = {
  matchId: number;
  leagueId: number;
  descriptions?: MatchDescription[];
  onRefetchCard: () => void;
};

export const MatchesDescription: FC<MatchesDescriptionProps> = ({
  matchId,
  leagueId,
  descriptions = [],
  onRefetchCard,
}) => {
  const description = descriptions[0];
  const [edit, setEdit] = useState(false);
  const { formProps, form } = useForm<{ description: string }>({
    action: description ? "edit" : "create",
    resource: "matchesDescription",
    meta: { matchId, leagueId },
    dataProviderName: "matchesDescriptionDataProvider",
    redirect: false,
    ...successNotification({
      successData: {
        message: description ? "Описание изменено" : "Описание добавлено",
        type: "success",
      },
      callback: () => {
        setEdit(false);
        onRefetchCard();
      },
    }),
    ...errorNotification({}),
  });

  const { modalProps, show, close } = useModal();
  const { mutate: deleteMutate } = useDelete();

  const handleEdit = () => {
    setEdit(true);
  };

  const handleStopEdit = () => {
    setEdit(false);
    form.setFieldValue("description", description?.description);
  };

  const handleDelete = () => {
    deleteMutate({
      dataProviderName: "matchesDescriptionDataProvider",
      resource: "matchesDescription",
      id: "",
      meta: { matchId },
      ...successNotification({
        successData: {
          message: "Описание успешно удалено",
          type: "success",
        },
        callback: () => {
          onRefetchCard();
          close();
        },
      }),
      ...errorNotification({}),
    });
  };

  if (!description) {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        <Form
          style={{
            width: "100%",
            display: "flex",
            alignItems: "flex-start",
            gap: 8,
          }}
          {...formProps}
          layout={"vertical"}
        >
          <Form.Item
            name={"description"}
            label={"Описание:"}
            style={{ width: "100%" }}
            rules={[
              {
                required: true,
                message: "Необходимо указать описание",
              },
              {
                max: 1000,
                min: 5,
                message: "Не более 1000 символов и не менее 5 символов",
              },
            ]}
          >
            <Input placeholder={"Укажите описание"}></Input>
          </Form.Item>
          <Button className={s.button} type={"primary"} htmlType={"submit"}>
            Добавить описание
          </Button>
        </Form>
      </div>
    );
  }

  return (
    <>
      {!edit ? (
        <AppViewCard label={"Описание:"}>
          <Space
            direction={"horizontal"}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
            size={24}
          >
            <TextField value={description.description} />
            <div className={s.wrapContainer}>
              <EditOutlined
                style={{
                  fontSize: 20,
                  cursor: "pointer",
                  color: "var(--accent-main)",
                }}
                onClick={handleEdit}
              />
              <DeleteOutlined
                onClick={show}
                style={{
                  color: "var(--danger)",
                  fontSize: 20,
                  cursor: "pointer",
                }}
              />
            </div>
          </Space>
        </AppViewCard>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            gap: 16,
          }}
        >
          <Form
            style={{
              width: "100%",
              display: "flex",
              gap: 8,
            }}
            {...formProps}
            initialValues={{ description: description.description }}
            layout={"horizontal"}
          >
            <Form.Item
              name={"description"}
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: "Необходимо указать описание",
                },
                {
                  max: 1000,
                  min: 5,
                  message: "Не более 1000 символов и не менее 5 символов",
                },
              ]}
            >
              <Input placeholder={"Укажите описание"}></Input>
            </Form.Item>
            <Button type={"primary"} htmlType={"submit"}>
              Изменить описание
            </Button>
            <div className={s.iconContainer}>
              <CloseOutlined
                style={{
                  fontSize: 20,
                  cursor: "pointer",
                  color: "var(--accent-main)",
                }}
                onClick={handleStopEdit}
              />
            </div>
          </Form>
        </div>
      )}
      <Modal
        okText={"Удалить описание"}
        cancelText={"Отмена"}
        onOk={handleDelete}
        title={"Подтверждение"}
        onCancel={close}
        {...modalProps}
      >
        Вы уверены, что хотите удалить описание?
      </Modal>
    </>
  );
};
